module.exports = __webpack_public_path__ + "static/media/adidas.b3b38718.svg";